import script from "./VVVUsersTableRowNew.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVUsersTableRowNew.vue?vue&type=script&setup=true&lang=js"

import "./VVVUsersTableRowNew.vue?vue&type=style&index=0&id=2ce50842&scoped=true&lang=css"
import "./VVVUsersTableRowNew.vue?vue&type=style&index=1&id=2ce50842&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce50842"]])

export default __exports__